import { useContext } from 'react';
import ApiClient from '../api/ApiClient';
import { MainContext } from '../context/storeContext';

export const useApi = (): ApiClient => useContext(MainContext)?.apiClient as ApiClient;